(function () {
  'use strict';

  var mainImg = document.getElementById('lumi-main-img');
  var mainVideo = document.getElementById('lumi-main-video');
  var thumbs = document.querySelectorAll('[data-thumb]');
  var thumbsScroller = document.getElementById('lumi-thumbs');
  var scrollButtons = document.querySelectorAll('[data-thumb-scroll]');
  var media = [];

  if (!mainImg && !mainVideo) return;

  thumbs.forEach(function (thumb) {
    var img = thumb.querySelector('img');
    if (!img) return;

    var type = thumb.getAttribute('data-media-type') || 'image';
    var largeSrc = img.getAttribute('data-large-src') || img.src.replace(/([?&])width=\d+/, '$1width=1200');
    media.push({
      type: type,
      src: type === 'video' ? thumb.getAttribute('data-video-src') : largeSrc,
      poster: thumb.getAttribute('data-poster-src') || largeSrc,
      alt: img.getAttribute('alt') || (mainImg && mainImg.getAttribute('alt')) || ''
    });
  });

  function showImage(item) {
    if (!mainImg || !item) return;
    if (mainVideo) {
      mainVideo.pause();
      mainVideo.hidden = true;
    }
    mainImg.hidden = false;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = item.src;
    mainImg.alt = item.alt;
    mainImg.setAttribute('loading', 'eager');
  }

  function showVideo(item) {
    if (!mainVideo || !item || !item.src) return;
    if (mainImg) mainImg.hidden = true;
    mainVideo.hidden = false;
    if (item.poster) mainVideo.poster = item.poster;
    if (mainVideo.getAttribute('src') !== item.src) {
      mainVideo.src = item.src;
      mainVideo.load();
    }
    mainVideo.play().catch(function () {});
  }

  function activateThumb(thumb) {
    var idx = parseInt(thumb.dataset.thumb, 10);
    var item = media[idx];
    if (!item) return;
    if (item.type === 'video') showVideo(item);
    else showImage(item);
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      activateThumb(thumb);
    });
  });

  function updateScrollButtons() {
    if (!thumbsScroller || !scrollButtons.length) return;

    var hasOverflow = thumbsScroller.scrollHeight > thumbsScroller.clientHeight + 1;
    scrollButtons.forEach(function (button) {
      button.hidden = !hasOverflow;
    });
  }

  if (thumbsScroller && scrollButtons.length) {
    scrollButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = button.getAttribute('data-thumb-scroll') === 'up' ? -1 : 1;
        thumbsScroller.scrollBy({
          top: direction * (thumbsScroller.clientHeight * 0.75),
          behavior: 'smooth'
        });
      });
    });

    updateScrollButtons();
    window.addEventListener('resize', updateScrollButtons);
    window.addEventListener('load', updateScrollButtons);
  }

  document.addEventListener('variant:changed', function (e) {
    if (e.detail && e.detail.featured_image && mainImg) {
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = e.detail.featured_image.src;
      mainImg.hidden = false;
      if (mainVideo) {
        mainVideo.pause();
        mainVideo.hidden = true;
      }
    }
  });
})();
